const getters = {
  userInfo: state => {
    if (JSON.stringify(state.user.userInfo) === '{}') {
      return JSON.parse(window.sessionStorage.getItem('userInfo') || '{}')
    } else {
      return state.user.userInfo || {}
    }
  },
}

export default getters
